import { pinnedLinkLimit, PinnedLink } from "@megaron/docs-contracts";
import { useClientManager } from "@megaron/react-clients";
import { newUuid, Uuid } from "@megaron/uuid";

export const pinnedLinksQueryKey = ["docs", "getPinnedLinks"];

export const usePinnedLinks = () => {
  const query = useClientManager("docs")
    .getPinnedLinks()
    .useQuery({}, { queryKey: pinnedLinksQueryKey, keepPreviousData: true });

  const saveMutation = useClientManager("docs")
    .savePinnedLink()
    .useMutation({
      onSuccess: (_data, _variables, { queryClient }) => {
        queryClient.refetchQueries({ queryKey: pinnedLinksQueryKey });
      },
    });

  const deleteMutation = useClientManager("docs")
    .deletePinnedLink()
    .useMutation({
      onSuccess: (_data, _variables, { queryClient }) => {
        queryClient.refetchQueries({ queryKey: pinnedLinksQueryKey });
      },
    });

  const links: PinnedLink[] = query.data ?? [];

  const findByUri = (uri: string): PinnedLink | undefined => links.find((link) => link.uri === uri);

  return {
    links,
    error: query.error ?? null,
    isLoading: query.isLoading && query.data === undefined,
    refetch: query.refetch,

    isLimitReached: links.length >= pinnedLinkLimit,
    findByUri,

    savePin: (input: { id?: Uuid; uri: string; name: string }) =>
      saveMutation.mutateAsync({ id: input.id ?? newUuid(), uri: input.uri, name: input.name }),
    isSaving: saveMutation.isLoading,

    removePin: (id: Uuid) => deleteMutation.mutateAsync({ id }),
    isRemoving: deleteMutation.isLoading,
  };
};
